import { apiFetch } from "../utils/apiFetch";
export const PORTFOLIO_TEXTFELDER = [
  ["produktname", "Produktname gemäß Produktpartner"],
  ["tarif", "Tarif"],
  ["apBasis", "AP Basis"],
  ["apTyp", "AP Typ"],
  ["apHoehe", "AP Höhe"],
  ["lapBasis", "LAP Basis"],
  ["lapTyp", "LAP Typ"],
  ["lapHoehe", "LAP Höhe"],
  ["bpBasis", "BP Basis"],
  ["bpTyp", "BP Typ"],
  ["bpHoehe", "BP Höhe"],
] as const;
export type PortfolioTextfeld = (typeof PORTFOLIO_TEXTFELDER)[number][0];
export type PortfolioDaten = Record<PortfolioTextfeld, string> & {
  produktpartnerContactId: number;
  insuranceProductId: number;
  sort: number;
};
export type PortfolioEintrag = PortfolioDaten & {
  id: number;
  abrechnungContactId: number;
  bearbeitbar: boolean;
  abrechnungName: string;
  produktpartnerName: string;
  insuranceProductName: string;
};
export type PortfolioSicht = {
  bearbeitbar: boolean;
  kooperation: boolean;
  eintraege: PortfolioEintrag[];
};
export type PortfolioProdukt = {
  id: number;
  name: string;
  insuranceClassID: number;
  sortOrder: number;
  active: boolean;
};
export type PortfolioKlasse = {
  id: number;
  insuranceClass: string;
  sortOrder: number;
  active: boolean;
};
export type PortfolioPartner = { id: number; name: string };
const get = async <T>(url: string, signal?: AbortSignal) =>
  (await apiFetch<T>(url, { signal })).data;
const path = (id: number) => `contact/${id}/partnerportfolio`;
const write = async (url: string, method: string, data?: PortfolioDaten) =>
  (
    await apiFetch<PortfolioEintrag>(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: data ? JSON.stringify(data) : undefined,
    })
  ).data;
export const partnerPortfolioService = {
  list: (id: number, signal?: AbortSignal) =>
    get<PortfolioSicht>(path(id), signal),
  overview: (signal?: AbortSignal) =>
    get<PortfolioEintrag[]>("partnerportfolio", signal),
  partner: (signal?: AbortSignal) =>
    get<PortfolioPartner[]>("partnerportfolio/produktpartner", signal),
  katalog: async (signal?: AbortSignal) => {
    const [klassen, produkte] = await Promise.all([
      get<PortfolioKlasse[]>("insurance-class", signal),
      get<PortfolioProdukt[]>("insurance-product", signal),
    ]);
    return { klassen, produkte };
  },
  create: (id: number, data: PortfolioDaten) => write(path(id), "POST", data),
  update: (id: number, entryId: number, data: PortfolioDaten) =>
    write(`${path(id)}/${entryId}`, "PUT", data),
  remove: (id: number, entryId: number) =>
    write(`${path(id)}/${entryId}`, "DELETE"),
};
